import React from 'react'
import { CSSObject, SerializedStyles, css } from '@emotion/core'
import { isEmpty } from 'lodash'

export const useSearchedConditions = (searchedConditions: Record<string, any>) => {
  const onlyHasValues = Object.entries(searchedConditions).filter(([_, value]) => !isEmpty(value))

  const SearchedConditionValues: React.FC<{ customCss?: CSSObject | SerializedStyles }> = ({ customCss }) => {
    return (
      <div css={[searchConditionStyle, customCss]}>
        {onlyHasValues?.map(([key, values], index) => (
          <span
            key={index}
          >{`${key}：${Array.isArray(values) ? values.join('') : values}${index + 1 !== onlyHasValues.length ? '、' : ''}`}</span>
        ))}
      </div>
    )
  }

  return { SearchedConditionValues }
}

export const searchConditionStyle = css({
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap',
  minWidth: 0,
  fontSize: 12,
  lineHeight: 1.5,
  fontWeight: 'bold',
  color: '#676767',
  letterSpacing: '0.6px',
  marginLeft: '8px',
})
